import React from "react";

const InfoIcon = ({ color, size }) => {
  return (
    <svg
      width={size ? size : "6"}
      height={size ? size : "12"}
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.07766 3.17438C5.23572 3.0979 6.09285 2.3265 5.9909 1.4517C5.89034 0.576886 4.8692 -0.0703428 3.71113 0.00613688C2.55307 0.08264 1.69594 0.853765 1.79718 1.72858C1.89849 2.60394 2.91963 3.25089 4.07766 3.17438Z"
        fill="#2D3748"
      />
      <path
        d="M4.71332 9.52479C4.21273 9.66321 3.36916 10.0532 3.36916 10.0532C3.36916 10.0532 4.00879 7.81962 4.03519 7.72237C4.30544 6.74196 5.07346 5.35837 4.03305 4.51723C3.30856 3.93277 2.37725 4.09007 1.55648 4.68315C1.01453 5.07448 0.727153 5.32471 0.225162 5.74543C0.0219329 5.9159 -0.0550772 6.07509 0.0411696 6.32476C0.144553 6.59465 0.562428 6.72851 0.931808 6.62643C1.4324 6.48827 2.27529 6.09827 2.27529 6.09827C2.27529 6.09827 1.8845 7.45763 1.68984 8.13742C1.66272 8.23438 0.570992 10.7928 1.61211 11.634C2.3366 12.2187 3.2672 12.0612 4.08868 11.4683C4.63064 11.077 4.91801 10.8268 5.42 10.4058C5.62323 10.2356 5.69953 10.0764 5.60399 9.82672C5.49987 9.55711 5.0827 9.42297 4.71332 9.52479Z"
        fill="#2D3748"
      />
    </svg>
  );
};

export default InfoIcon;
